import { useGetCurrentUserOrganizationAccessQuery, useGetOrganizationDetailsQuery } from '../../../__generated__/chirp/com/hubspot/multi/account/configuration/manager/rpc/MultiAccountOrganizationChirpService.hooks';
const useFetchOrgData = () => {
  var _orgDetailsData$enric;
  const {
    data: orgAccessData,
    loading: orgAccessLoading
  } = useGetCurrentUserOrganizationAccessQuery();
  const {
    data: orgDetailsData,
    loading: orgDetailsLoading
  } = useGetOrganizationDetailsQuery();
  const portalsInOrgCount = (orgDetailsData === null || orgDetailsData === void 0 || (_orgDetailsData$enric = orgDetailsData.enrichedOrganization) === null || _orgDetailsData$enric === void 0 ? void 0 : _orgDetailsData$enric.enrichedAccountsOrganization.length) || 0;
  const isInOrg = Boolean(portalsInOrgCount);
  const isOrgSuperAdmin = Boolean(orgAccessData === null || orgAccessData === void 0 ? void 0 : orgAccessData.organizationAdmin);
  return {
    isInOrg,
    isInOrgAndSuperAdmin: isInOrg && isOrgSuperAdmin,
    portalsInOrgCount,
    loading: orgAccessLoading || orgDetailsLoading
  };
};
export default useFetchOrgData;